import React, { useState } from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import { ValueOptions } from './ValueOptions'
import { ValueOptionsInterface, TypeVariableOptions } from '../types'

type valueSetupProps = {
    valueOptions: ValueOptionsInterface
    index?: number
    removeValue?: (any: number) => void
    isMainValue?: boolean
    changeValueOptions: (
        valueOptions: ValueOptionsInterface,
        configItemType: string,
        value: any,
        itemKey: string,
        indexSecondaryValue?: number
    ) => void
    variableOptions: TypeVariableOptions
    setIsIconChoserOpen: (value: boolean) => void
    setSaveIconAux: (index: number) => void
}

export const ValueSetup = ({
    index,
    valueOptions,
    removeValue,
    isMainValue,
    changeValueOptions,
    variableOptions,
    setIsIconChoserOpen,
    setSaveIconAux
}: valueSetupProps): JSX.Element => {
    const [isOpen, setIsOpen] = useState(false)

    const checkPropIsOn = (value: boolean) => {
        return value ? i18n('On') : i18n('Off')
    }

    return (
        <Container>
            <ValueInfo>
                <span>
                    <b>{valueOptions?.variable.value}</b>
                </span>

                <ValuePropsDiv>
                    <span>{checkPropIsOn(valueOptions?.label.isEnabled)}</span>
                    <span>{checkPropIsOn(valueOptions?.prefix.isEnabled)}</span>
                    <span>{checkPropIsOn(valueOptions?.sufix.isEnabled)}</span>
                    <span>{checkPropIsOn(valueOptions?.trend.isEnabled)}</span>
                </ValuePropsDiv>

                <ButtonsDiv>
                    {!isMainValue && index !== null && (
                        <button onClick={() => removeValue(index)}>
                            <i className="far fa-trash-alt" />
                        </button>
                    )}

                    <button onClick={() => setIsOpen(!isOpen)}>
                        <i className={`fas fa-chevron-${!isOpen ? 'down' : 'up'}`} />
                    </button>
                </ButtonsDiv>
            </ValueInfo>

            {isOpen && (
                <ValueOptions
                    index={index}
                    valueOptions={valueOptions}
                    changeValueOptions={changeValueOptions}
                    variableOptions={variableOptions}
                    setIsIconChoserOpen={setIsIconChoserOpen}
                    setSaveIconAux={setSaveIconAux}
                />
            )}
        </Container>
    )
}

export const ValuePropsDiv = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    > span {
        display: flex;
        align-items: flex-start;
        width: 100%;
    }
`

const ValueInfo = styled.div`
    padding: 0px 24px;
    height: 32px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    > span {
        max-width: inherit;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    > span,
    div {
        margin-left: 4px;
    }

    > :nth-child(1) {
        width: 30%;
    }
    > :nth-child(2) {
        width: 55%;
    }
    > :nth-child(3) {
        width: 15%;
        display: flex;
        justify-content: flex-end;
    }
`

const ButtonsDiv = styled.div`
    button {
        border: none;
        background: none;
        margin: 0;
        width: 20px;
        height: 16px;
        display: flex;
        align-items: center;
    }

    .fa-trash-alt {
        color: ${({ theme }) => theme?.['red-500'] || '#D9534F'};
        font-size: 11px;

        :hover {
            color: ${({ theme }) => theme?.['red-700'] || '#C43535'};
        }
    }

    .fa-chevron-down,
    .fa-chevron-up {
        color: ${({ theme }) => theme?.['blue-500'] || '#37A3EF'};
        font-size: 13px;

        :hover {
            color: ${({ theme }) => theme?.['blue-700'] || '#008AC7'};
        }
    }
`

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 8px 0;
    background: ${({ theme }) => theme?.['gray-0'] || '#FFFFFF'};
    border: 1px solid ${({ theme }) => theme?.['gray-400'] || '#C8CCD4'};
    border-radius: 3px;
`
